<template>
  <v-dialog class="md-4" id="edit-profile" max-width="700px" persistent v-model="popup">
    <v-form>
      <v-card>
        <v-card-title class="white" dark>
          <span>Change Password</span>
          <v-spacer></v-spacer>
          <v-btn small fab depressed class="mr-2 white--text" color="red" sole @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <span>
            <v-btn
              fab
              small
              depressed
              color="green"
              :loading="loading"
              :disabled="loading"
              class="mr-2 white--text"
              sole
              @click="updatesPassword"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </span>         
        </v-card-title>
         <v-divider></v-divider>
        <v-container class="pa-6">
          <v-layout row v-if="errors">
            <v-flex>
              <Alert @dismissed="onDismissed" :text="errors"></Alert>
            </v-flex>
          </v-layout>

          <v-row>
            <v-col cols="12">
              <v-label>Enter Old Password</v-label>
              <InputField
                v-model="form.old_password"
                type="password"
                :setectVale="form.old_password"
                @changeInput="form.old_password = $event"
              />
            </v-col>
            <v-col cols="12">
              <v-label>Enter New Password</v-label>
              <InputField
                v-model="form.password"
                type="password"
                 :setectVale="form.password"
                @changeInput="form.password = $event"
              />
            </v-col>
            <v-col cols="12">
              <v-label>Re-enter New Password</v-label>
              <InputField
                v-model="form.password_confirmation"
                type="password"
                 :setectVale="form.password_confirmation"
                @changeInput="form.password_confirmation = $event"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-form>
  </v-dialog>
</template>


<script>
import Alert from "@/components/shared/Alert";
import InputField from "@/components/shared/InputField";
import { AuthService } from "@/services/auth-service.js";
import { checkError } from "@/config/errors.js";

export default {
  name: "AddClassroom",
  props: ["popup", "member"],
  components: { Alert, InputField },

  data: () => ({
    form: {
      old_password: null,
      password: null,
      password_confirmation: null
    },
    errors: null,
    loading: false
  }),

  mounted() {
    this.onDismissed();
  },

  methods: {
    updatesPassword() {
      this.loading = true;
      this.errors = null;
      AuthService.updatePassword(this.form)
        .then(response => {
          this.loading = false;
          if (response.data.status_code === 200) {
            this.reset();
            this.$emit("successReset", true);
          }
        })
        .catch(error => {
          this.loading = false;
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },

    close() {
      this.reset();
      this.onDismissed();
      this.$emit("modalStatus", !this.popup);
    },
    reset() {
      this.form.old_password = "";
      this.form.password = "";
      this.form.password_confirmation = "";
    }
  }
};
</script>

